import { render, staticRenderFns } from "./ExtConfigCompoment.vue?vue&type=template&id=4e659930"
import script from "./ExtConfigCompoment.vue?vue&type=script&lang=js"
export * from "./ExtConfigCompoment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports